
document.addEventListener('DOMContentLoaded',function(){
  /* CURSOR */
  var cur=document.getElementById('cur'),curR=document.getElementById('curR');
  if(cur&&curR){
    var mx=0,my=0,rx=0,ry=0;
    document.addEventListener('mousemove',function(e){
      mx=e.clientX;my=e.clientY;
      cur.style.left=mx+'px';cur.style.top=my+'px';
    });
    (function loop(){rx+=(mx-rx)*.1;ry+=(my-ry)*.1;curR.style.left=rx+'px';curR.style.top=ry+'px';requestAnimationFrame(loop)})();
    document.querySelectorAll('a,button,.pc,.ing,.ptc,.rc,.sym').forEach(function(el){
      el.addEventListener('mouseenter',function(){cur.classList.add('big')});
      el.addEventListener('mouseleave',function(){cur.classList.remove('big')});
    });
  }

  /* HERO CANVAS */
  var cnv=document.getElementById('hcv');
  if(cnv){
    var ctx=cnv.getContext('2d'),W,H,pts=[];
    function rsz(){W=cnv.width=cnv.offsetWidth;H=cnv.height=cnv.offsetHeight;}
    rsz();window.addEventListener('resize',function(){rsz();init();});
    function init(){pts=[];var n=Math.floor(W*H/18000);for(var i=0;i<n;i++)pts.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-.5)*.2,vy:(Math.random()-.5)*.2,r:Math.random()*1.2+.4,a:Math.random()*.7+.2});}
    init();
    function draw(){ctx.clearRect(0,0,W,H);pts.forEach(function(p){p.x=(p.x+p.vx+W)%W;p.y=(p.y+p.vy+H)%H;ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);ctx.fillStyle='rgba(200,168,75,'+p.a*.45+')';ctx.fill();pts.forEach(function(q){var d=Math.hypot(p.x-q.x,p.y-q.y);if(d<120){ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(q.x,q.y);ctx.strokeStyle='rgba(200,168,75,'+(1-d/120)*.045+')';ctx.lineWidth=.5;ctx.stroke();}});});requestAnimationFrame(draw);}
    draw();
  }

  /* SCROLL */
  var bar=document.getElementById('scrollBar'),hdr=document.getElementById('ap-hdr'),sticky=document.getElementById('stickyEl');
  window.addEventListener('scroll',function(){
    var h=document.documentElement.scrollHeight-window.innerHeight;
    if(bar)bar.style.width=(scrollY/h*100)+'%';
    if(hdr)hdr.classList.toggle('solid',scrollY>60);
    if(sticky)sticky.classList.toggle('show',scrollY>700);
  },{passive:true});

  /* HERO LINE */
  setTimeout(function(){var hl=document.getElementById('hdivEl');if(hl)hl.classList.add('on');},700);

  /* REVEAL */
  var rvObs=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting)e.target.classList.add('on');});},{threshold:.07});
  document.querySelectorAll('.rv').forEach(function(el){rvObs.observe(el);});

  /* COUNTERS */
  var cntObs=new IntersectionObserver(function(en){en.forEach(function(e){
    if(!e.isIntersecting||e.target.dataset.done)return;
    e.target.dataset.done='1';
    var target=+e.target.dataset.target,suf=e.target.dataset.suffix||'',t0=null;
    (function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/1600,1),ease=1-Math.pow(1-p,3),val=Math.floor(ease*target);e.target.textContent=(val>=1000?val.toLocaleString():val)+suf;if(p<1)requestAnimationFrame(step);})(performance.now());
  });},{threshold:.5});
  document.querySelectorAll('[data-target]').forEach(function(el){cntObs.observe(el);});

  /* COUNTDOWN */
  if(false){
  }

  /* FAQ */
  document.querySelectorAll('.faq-q').forEach(function(q){
    q.addEventListener('click',function(){var item=q.closest('.faq-item'),was=item.classList.contains('open');document.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open');});if(!was)item.classList.add('open');});
  });

  /* SMOOTH SCROLL */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){var t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}});
  });

  /* DRAWER */
  window.toggleDrawer=function(){
    var d=document.getElementById('drawer'),h=document.getElementById('hbgEl');
    if(!d||!h)return;
    d.classList.toggle('open');h.classList.toggle('open');
    var spans=h.querySelectorAll('span');
    if(h.classList.contains('open')){spans[0].style.transform='rotate(45deg) translate(4px,4px)';spans[1].style.opacity='0';spans[2].style.transform='rotate(-45deg) translate(4px,-4px)';}
    else{spans.forEach(function(s){s.style.transform='';s.style.opacity='1';});}
  };

  /* SEARCH */
  window.toggleSearch=function(){var o=document.getElementById('srchEl');if(!o)return;o.classList.toggle('open');if(o.classList.contains('open'))setTimeout(function(){document.getElementById('srchInp').focus();},100);};
  window.closeSearch=function(e){if(e.target===document.getElementById('srchEl'))document.getElementById('srchEl').classList.remove('open');};
  document.addEventListener('keydown',function(e){if(e.key==='Escape')document.getElementById('srchEl').classList.remove('open');});

  /* TOASTS */
  /*var toasts=[
    {n:'Thomas M. from Paris',m:'just ordered the 3-Bottle Protocol',t:'2 min ago'},
    {n:'Alexandre D. from Lyon',m:'just ordered the 6-Bottle Protocol',t:'5 min ago'},
    {n:'James W. from London',m:'just started his 60-Day Protocol',t:'8 min ago'},
    {n:'Marco R. from Milan',m:'just ordered the 3-Bottle Protocol',t:'12 min ago'},
    {n:'Henrik S. from Stockholm',m:'just started his 60-Day Protocol',t:'16 min ago'},
  ];
  var ti=0;
  function showT(){var d=toasts[ti%toasts.length];ti++;var toast=document.getElementById('toast');if(!toast)return;document.getElementById('tName').textContent=d.n;document.getElementById('tMsg').textContent=d.m;document.getElementById('tTime').textContent=d.t;toast.classList.add('show');setTimeout(function(){toast.classList.remove('show');},4200);}
  setTimeout(function(){showT();setInterval(showT,12000);},6000);*/
});
